import type { TenantPublicConfig } from '@missions/types';

let appTitle = 'Missions';
let unread = 0;
let page = '';

function render(): void {
  document.title = `${unread > 0 ? `(${unread > 99 ? '99+' : unread}) ` : ''}${page ? `${page} · ` : ''}${appTitle}`;
}

/** Tenant title + favicon + theme colour (white-label; docs/SEO-META.md). Runs once at boot. */
export function applyTenantHead(t: TenantPublicConfig): void {
  appTitle = t.appTitle || 'Missions';
  const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (meta) meta.content = t.brandColor;
  if (t.iconUrl) {
    document.querySelectorAll<HTMLLinkElement>('link[rel="icon"], link[rel="apple-touch-icon"]').forEach((l) => {
      l.href = t.iconUrl!;
    });
  }
  render();
}

/** `{Page} · {Tenant title}`, with the unseen-notification count prefix. */
export function setPageTitle(p: string): void {
  page = p;
  render();
}
export function setUnreadTitle(n: number): void {
  unread = n;
  render();
}
